import { Provider } from '@angular/core';
import { FormFactory } from './ui-abstractions';

export const provideFormFactory = (ComponentFormFactory: any): Provider[] => [
  {
    provide: FormFactory,
    useClass: ComponentFormFactory,
  }
];